import { SignEnvironment } from '.';

const envStaging: SignEnvironment = {
  domain: 'sign.yabawt-dev.com'
};

export default envStaging;
